var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showConclusion)?_c('div',{staticClass:"badge",class:_vm.resultStatusClass},[_vm._v("\n  "+_vm._s(_vm.statusName)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }